// src/components/ConfirmationModal.jsx
import React from 'react';
import {CheckCircle2, X} from 'lucide-react';

export default function ConfirmationModal({isOpen, onConfirm, onCancel, name}) {
    if (!isOpen) return null;

    return (
        <>
            {/* Затемнение */}
            <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40" onClick={onCancel}/>

            {/* Модалка */}
            <div className="fixed inset-x-4 bottom-28 z-50 animate-ios-bottom-sheet">
                <div className="bg-white rounded-3xl shadow-2xl border border-gray-200 p-6">
                    <div className="flex items-center justify-between mb-4">
                        <h3 className="text-2xl font-bold text-gray-900">Отметить выезд?</h3>
                        <button onClick={onCancel} className="text-gray-400 hover:text-gray-600">
                            <X size={28}/>
                        </button>
                    </div>

                    <div className="flex items-center gap-4 mb-6">
                        <CheckCircle2 className="w-12 h-12 text-green-600"/>
                        <div>
                            <p className="text-xl font-semibold">{name}</p>
                            <p className="text-gray-600">Гость выезжает сегодня</p>
                        </div>
                    </div>

                    <div className="flex gap-4">
                        <button
                            onClick={onCancel}
                            className="flex-1 py-4 rounded-2xl border border-gray-300 font-medium text-gray-700 hover:bg-gray-50 transition"
                        >
                            Отмена
                        </button>
                        <button
                            onClick={onConfirm}
                            className="flex-1 py-4 rounded-2xl bg-gradient-to-r from-red-500 to-pink-600 text-white font-bold hover:from-red-600 hover:to-pink-700 transition shadow-lg"
                        >
                            Да, выехал!
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
